import { ChangeEvent } from 'react';
import Input, { InputProps } from '../Form/Input/Input';
import IconButton from '../IconButton/IconButton';

export interface SearchInputProps extends Omit<InputProps, 'onChange'> {
  onChange: (value: string) => void;
}

const SearchInput = (props: SearchInputProps) => {
  const { onChange, value, ...rest } = props;

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const q = event.target.value;
    onChange(q);
  };

  const onClearClick = () => {
    onChange('');
  };

  const rightButton = (
    <IconButton
      _active={{ background: 'transparent' }}
      _hover={{ background: 'transparent' }}
      aria-label="Clear"
      iconName="Cross"
      onClick={onClearClick}
      variant="tertiary"
    />
  );
  const inputProps: InputProps = {
    leftIconColor: 'neutral.60',
    leftIconName: 'Magnifier',
    onChange: onInputChange,
    rightAddon: value ? rightButton : undefined,
    rightAddonPlacement: 'inside',
    type: 'text',
    value,
    ...rest,
  };
  return <Input {...inputProps} />;
};

export default SearchInput;
